<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人脸记忆功能</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			在视频流人脸识别过程中，打开人脸记忆功能，可区分对陌生人形成记忆, 便于需要再次识别陌生人的使用场景。
			该函数必须在SKFaceVideoTrackInit()初始化成功后才能调用
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public boolean SKFaceMemory (boolean EnableMemory)</code></pre>
		<h3 class="doc_main_h3">参数</h3>
             <pre class="doc_main_pre"><code class="doc_main_code">EnableMemory: true：打开“人脸记忆”功能，false：关闭“人脸记忆”功能（开启后：识别到“陌生人”，Name会返回“[StrangerID]”，
例如“[00000001]”、“[00000002]”，表示“陌生人1”、“陌生人2”。不开启：识别到“陌生人”，Name会返回“陌生人”。）</code></pre>     
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">boolean类型，true：开启/关闭人脸记忆功能成功，false：开启/关闭人脸记忆功能失败。注意: 关闭该项后不会清除之前已经获得的记忆, 只是将记忆封闭起来. </p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">//打开“人脸记忆功能”
boolean res = skFace.SKFaceMemory (true);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import TestResultStructure from '../../../../components/testResultStructure.vue';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'test-result-rtructure':TestResultStructure
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','拓展接口','人脸记忆功能'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/expand/faceConttest.vue